import {Box} from '@mantine/core';
import {useTranslation} from 'react-i18next';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';

// Global components
import TabBar from 'components/others/TabBar';
import {getMenuAvailabilityMode, getMenuRouteBasePath} from 'utils/menuAvailability';

// Local styles
import {useStyles} from './styles';

const MenuSidebar = () => {
	const {t} = useTranslation('translation', {keyPrefix: 'pages.menu.components.menuSidebar'});
	const {classes} = useStyles();
	const navigate = useNavigate();
	const location = useLocation();
	const menuBasePath = getMenuRouteBasePath(location.pathname);
	const menuMode = getMenuAvailabilityMode(location.pathname);

	const menus = [
		{label: t('mainMenu'), path: menuBasePath},
		{label: t('complexMenu'), path: `${menuBasePath}/complex`},
		{label: t('material'), path: `${menuBasePath}/material`},
		{label: t('requestStatus'), path: `${menuBasePath}/request-status`},
	];

	// Render
	return (
		<>
			<Box className={classes.container}>
				<TabBar
					tabs={menus}
					grow
					position="center"
					activeTab={menus.findIndex(menu => menu.path === location.pathname)}
					onTabChange={i => {
						navigate(menus[i].path);
					}}
				/>
				<Box className={classes.tabContent}>
					<Outlet key={menuMode} />
				</Box>
			</Box>
		</>
	);
};

export default MenuSidebar;
